import HTTPService from "@/services/http_service.js";
import { global } from "@/config/constants";

export default class PreAgendamentoService extends HTTPService {
  resource = "preagendamento";

  static build() {
    return new PreAgendamentoService();
  }

  getPaginatedList({ page, per_page, search, order, desc }) {
    return this.get(this.resource, {
      page,
      per_page,
      search,
      order,
      desc,
    });
  }

  async register(preagendamento) {
    const headers = new Headers();

    const token = JSON.parse(sessionStorage.getItem("vuex")).token;
    headers.append("Authorization", "Bearer " + token);

    const requestOptions = {
      method: "POST",
      body: preagendamento,
      headers: headers,
    };
    return await fetch(
      `${global.api.baseURL}/${this.resource}`,
      requestOptions
    ).then(async (response) => {
      return response;
    });
  }

  async editar(preAgendamentoId, preAgendamento) {
    const headers = new Headers();
    const token = JSON.parse(sessionStorage.getItem("vuex")).token;
    headers.append("Authorization", "Bearer " + token);

    const requestOptions = {
      method: "POST",
      body: preAgendamento,
      headers: headers,
    };
    return await fetch(
      `${global.api.baseURL}/${this.resource}/${preAgendamentoId}`,
      requestOptions
    ).then(async (response) => {
      return response;
    });
  }

  async deletar(preAgendamentoId) {
    const headers = new Headers();
    const token = JSON.parse(sessionStorage.getItem("vuex")).token;
    headers.append("Authorization", "Bearer " + token);

    const requestOptions = {
      method: "POST",
      headers: headers,
    };
    return fetch(
      `${global.api.baseURL}/${this.resource}/${preAgendamentoId}/deletar`,
      requestOptions
    ).then(async (response) => {
      return response;
    });
  }
}
